import { Fab, Grid, Icon, MuiThemeProvider, Typography } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import MoodIcon from '@material-ui/icons/Mood';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import moment from 'moment';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { loadById } from 'store/Orbita/Newzz/actions';
import NoDangerouslyHTML from 'v2/components/Shared/NoDangerouslyHTML';

import { openModalBF } from './modalBF';
import styles from '../styles';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

interface IRouteParams {
  newzzId: any;
}

interface IProps extends DispatchProp<any>, RouteComponentProps<IRouteParams>, StyledComponentProps {
  loadNewzz: any;
  currentNewzz: any;
  loadNewzzIsFetching: any;
  notProductRecovering: number;
}

class InfoNewzz extends React.Component<IProps, any> {
  componentDidMount() {
    const { match, loadNewzz } = this.props;
    if (match && match.params && match.params.newzzId) {
      loadNewzz(match.params.newzzId);
    }
  }

  onClick = () => {
    openModalBF(this.props.notProductRecovering);
  };

  render() {
    const { currentNewzz, classes, loadNewzzIsFetching, notProductRecovering } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <Link className={classes.hideOnPrint} to='/producer/news/list'>
            <Icon style={{ fontSize: 16, lineHeight: '21px' }}>chevron_left</Icon> Voltar para news
          </Link>
          <Grid
            container
            justify='center'
            alignItems='center'
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
          >
            <div className={classes.title}>{currentNewzz && currentNewzz.title && <h2>{currentNewzz.title}</h2>}</div>
            <Typography style={{ fontSize: '16px' }} className={classes.date}>
              Publicado em: {moment(currentNewzz.created_at).format('L')}
            </Typography>
          </Grid>

          {/* <Grid container justify='center' alignItems='center' style={{ marginTop: '0px', marginBottom: '5px' }}>
            <Slide direction={'up'} in={true}>
              <Typography className={classes.date}>Publicado em: {moment(currentNewzz.created_at).format('L')}</Typography>
            </Slide>
          </Grid> */}
          {loadNewzzIsFetching ? (
            <Spin />
          ) : currentNewzz ? (
            <Grid container justifyContent={'center'} alignItems='center'>
              <Grid item xs={12} md={10} lg={10} className={classes.content}>
                <NoDangerouslyHTML html={currentNewzz.content} />
                {currentNewzz.id === 210 && notProductRecovering > 0 && (
                  <Fragment>
                    <Grid item xs={12}>
                      <p>
                        Se você tem interesse em ativar a opção de RECUPERAÇÃO DE VENDAS PERDIDAS em TODOS os seus produtos, clique no link abaixo:
                      </p>
                    </Grid>
                    <Grid item xs={12}>
                      <Fab variant='extended' aria-label='like' onClick={this.onClick} className={classes.buttonBF}>
                        <MoodIcon className={classes.extendedIcon} />
                        QUERO ATIVAR A OPÇÃO DE RECUPERAÇÃO DE VENDAS PERDIDAS EM TODOS OS MEUS PRODUTOS
                      </Fab>
                    </Grid>
                  </Fragment>
                )}
              </Grid>
            </Grid>
          ) : null}
        </div>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    currentNewzz: state.orbita.Newzz.loadNewzz,
    loadNewzzIsFetching: state.orbita.Newzz.loadNewzz.isFetching,
    notProductRecovering: state.orbita.User.user.not_recovering,
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    loadNewzz: (id: number) => dispatch(loadById(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(styles(InfoNewzz));
